import designationOverviewPageActionTypes from '../actions/designation-overview-page-action-types';

const initialState = {
  loading: false,
  designation: null,
  designationCancelToken: null,
  signingRedirectUrl: null,
  isConfirmDialogVisible: false,
  confirmDialogText: null,
  confirmAction: null,
  successMessage: null,
  errorMessage: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case designationOverviewPageActionTypes.LOAD_DESIGNATION_OVERVIEW_PAGE_START:
      return {
        ...state,
        loading: true
      };
    case designationOverviewPageActionTypes.LOAD_DESIGNATION_OVERVIEW_PAGE_END:
      return {
        ...state,
        loading: false,
        designation: action.payload?.designation
      };
    case designationOverviewPageActionTypes.APPROVE_DESIGNATION_START:
      return {
        ...state,
        loading: true
      };
    case designationOverviewPageActionTypes.APPROVE_DESIGNATION_END:
      return {
        ...state,
        loading: false,
        designation: action.payload?.designation
      };
    case designationOverviewPageActionTypes.UNAPPROVE_DESIGNATION_START:
      return {
        ...state,
        loading: true
      };
    case designationOverviewPageActionTypes.UNAPPROVE_DESIGNATION_END:
      return {
        ...state,
        loading: false,
        designation: action.payload?.designation
      };
    case designationOverviewPageActionTypes.TOGGLE_DESIGNATION_CONFIRM_DIALOG:
      return {
        ...state,
        isConfirmDialogVisible: !state.isConfirmDialogVisible,
        confirmDialogText: action.payload?.confirmDialogText,
        confirmAction: action.payload?.confirmAction
      };
    case designationOverviewPageActionTypes.RESUBMIT_DESIGNATION_START:
      return {
        ...state,
        loading: true
      };
    case designationOverviewPageActionTypes.RESUBMIT_DESIGNATION_START:
      return {
        ...state,
        loading: false
      };
    case designationOverviewPageActionTypes.REMOVE_DESIGNATION_START:
      return {
        ...state,
        loading: true
      };
    case designationOverviewPageActionTypes.REMOVE_DESIGNATION_END:
      return {
        ...state,
        loading: false
      };
    case designationOverviewPageActionTypes.CANCEL_DESIGNATION_START:
      return {
        ...state,
        loading: true,
        successMessage: null,
        errorMessage: null
      };
    case designationOverviewPageActionTypes.CANCEL_DESIGNATION_END:
      return {
        ...state,
        loading: false,
        designation: action.payload?.designation ?? state.designation,
        successMessage: action.payload?.successMessage ?? null,
        errorMessage: action.payload?.errorMessage ?? null
      };
    case designationOverviewPageActionTypes.CLEANUP_DESIGNATION_OVERVIEW_PAGE:
      return initialState;
    default:
      return state;
  }
};
